<template>
  <div id="content">
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link
              :to="{ name: moduleName }"
              class="btn btn_back"
              v-translate>Seznam
          </router-link>
        </p>
        <h1 v-translate>Přidat operátora</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content" v-show="isActiveTab('settings', false)">
          <operator-basic-info
              :entity="entity"
              :all-brands="allBrands"
              :all-business-models="allBusinessModels"
              :upload-ready="uploadReady"
              :selected-file="selectedFile"
              :is-editable="$_createActionAllowed"
              @selected-file="selectedFile = arguments[0]"
              ref="operatorbasicinforef"
          ></operator-basic-info>
          <operator-contact :entity="entity"></operator-contact>
          <operator-licence
              :entity="entity"
              :is-editable="$_createActionAllowed"
              :subscriberTypeOptions="subscriberTypes"
              ref="operatorconfigurationref"
          ></operator-licence>
          <form-buttons
              :module-name="moduleName"
              :is-editable="$_createActionAllowed"
              :custom-submit-text="'Uložit vlastnosti' | translate"
              @submit-form="createEntity"
          ></form-buttons>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import OperatorBasicInfo from "@/components/views/operators/settings/OperatorBasicInfo"
import OperatorContact from "@/components/views/operators/settings/OperatorContact"
import OperatorLicence from "@/components/views/operators/settings/OperatorLicence"
import FormButtons from "@/components/common/FormButtons"

import detailActions from "@/components/mixins/detail-actions"
import operators from "@/components/views/operators/mixins/operators"

export default {
  name: "OperatorNew",
  components: {
    FormButtons,
    OperatorLicence,
    OperatorContact,
    OperatorBasicInfo
  },
  mixins: [detailActions, operators],
  created(OperatorService) {
    this.entityService = OperatorService
    this.getOperatorFormData()
  },
  methods: {
    getOperatorFormData() {
      this.entityService.getFormData()
          .then(data => {
            this.allBrands = this.prependWithUndefinedOptions(data['all_brands'])
            this.allBusinessModels = this.prependWithUndefinedOptions(data['all_business_models'])
            this.subscriberTypes = data['subscriber_types']
          })
          .catch(function (error) {
            this.setErrorMessage(this._processDetailErrorMessage(error))
          }.bind(this))
    },
    createEntity(redirect = false) {
      let preProcessedParams = this._beforeCreateEntityActions({...this.entity})
      this.entityService.createEntity(this.filterFormParams(preProcessedParams))
          .then(data => {
            this.saveLastVisited(data.id)
            this.reloadOperatorList(data.id)

            Promise.resolve(this.uploadLogo(data.id))
                .then(() => {
                  if (redirect === true) {
                    this.redirect(this.moduleName)
                  } else {
                    this.redirect(this.detailPageRouteName, {id: data.id})
                  }
                })
          })
          .catch(function (error) {
            this.setErrorMessage(this._processDetailErrorMessage(error))
          }.bind(this))
    },
    reloadOperatorList(operatorId) {
      this.entityService.getOperators()
      .then(data => {
        let operators = data.operators
        this.setOwnerSetting('operators-simple-list', operators)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/operators/OperatorNew.vue